import { useEffect } from 'react'
import { TableContainer, Table, TableHead, TableCell, TableRow, Paper, TableBody, Typography, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { downloadDocument, getBiocharVolumes } from '../../../../../actions/tigercat-burns/tigercat-actions';
import moment from 'moment';

const BiocharData = ({ projectId, project }) => {
    const dispatch = useDispatch()

    const biocharVolumes = useSelector(state => state.tigercatBurnsReducer.biocharVolumes.data)

    useEffect(() => {
        dispatch(getBiocharVolumes(projectId));
    }, [dispatch, projectId])

    const handleDownload = async () => {
        try {
            dispatch(downloadDocument(projectId, 'biochar_mass_bins')).then((response) => {

                // Create a downloadable link for the Excel file
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${project}_biochar_mass_bins.xlsx`); // Set the file name
                document.body.appendChild(link);
                link.click();
                link.remove();
            })

        } catch (err) {
            console.error('Error downloading Biochar Mass Bins:', err);
        }
    };

    return (<>
        <h2>Biochar Mass - Bins</h2>
        <TableContainer key={0} component={Paper} sx={{ height: 'auto' }}>
            <Button variant='contained' sx={{ height: 'auto', float: 'right', mt: 2, mb: 2 }} onClick={handleDownload}>Download Excel</Button>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell size="small" align="left">
                            User
                        </TableCell>
                        <TableCell size="small" align="left">
                            Date
                        </TableCell>
                        <TableCell size="small" align="left">
                            Submission Date
                        </TableCell>
                        <TableCell size="small" align="left">
                            Bin Used
                        </TableCell>
                        <TableCell size="small" align="left">
                            Measurement (inch)
                        </TableCell>
                        <TableCell size="small" align="left">
                            Measurement Photo
                        </TableCell>
                        <TableCell size="small" align="left">
                            Moisture Content
                        </TableCell>
                        <TableCell size="small" align="left">
                            Dry Matter
                        </TableCell>
                        <TableCell size="small" align="left">
                            Equipment Used
                        </TableCell>
                        <TableCell size="small" align="left">
                            Volume Biochar (m3)
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {biocharVolumes?.map((data, index) => {
                        return (
                            <TableRow key={index}>
                                <TableCell size="small" align="left">{data.user_name}</TableCell>
                                <TableCell size="small" align="left">{moment(data.created_at).format('MM-DD-YY')}</TableCell>
                                <TableCell size="small" align="left">
                                    {data.submitted_at !== null ? moment(data.submitted_at).format('MM-DD-YY') : null}
                                </TableCell>
                                <TableCell size="small" align="left">{data.bin_used_name}</TableCell>
                                <TableCell size="small" align="left">{data.depth_measurement}</TableCell>
                                <TableCell size="small" align="left">{data.measurement_photo === 'null' ? null : <a href={data.measurement_photo} target="_blank" rel="noreferrer">Photo</a>}</TableCell>
                                <TableCell size="small" align="left">{data.moisture_content === null ? <Typography sx={{ color: 'darkorange' }}>Undetermined</Typography> : data.moisture_content}</TableCell>
                                <TableCell size="small" align="left">{data.dry_matter === null ? <Typography sx={{ color: 'darkorange' }}>Undetermined</Typography> : data.dry_matter}</TableCell>
                                <TableCell size="small" align="left">{data.equipment_used_name}</TableCell>
                                <TableCell size="small" align="left">{data.biochar_volume}</TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    </>

    )
}

export default BiocharData